import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-error",
  "use": "icon-icon-error-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-icon-error\">\r\n<g>\r\n\t<circle fill=\"#FF4040\" cx=\"8\" cy=\"8\" r=\"8\" />\r\n\t<g>\r\n\t\t<path fill=\"#FFFFFF\" d=\"M11.672,11.672c-0.169,0.17-0.442,0.17-0.611,0L4.328,4.939c-0.169-0.169-0.169-0.443,0-0.611l0,0\r\n\t\t\tc0.169-0.17,0.443-0.17,0.612,0l6.732,6.732C11.842,11.229,11.842,11.504,11.672,11.672L11.672,11.672z\" />\r\n\t\t<path fill=\"#FFFFFF\" d=\"M4.328,11.672c-0.169-0.168-0.169-0.442,0-0.611l6.733-6.732c0.169-0.17,0.442-0.17,0.611,0l0,0\r\n\t\t\tc0.17,0.168,0.17,0.442,0,0.611l-6.732,6.732C4.771,11.842,4.497,11.842,4.328,11.672L4.328,11.672z\" />\r\n\t</g>\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-error.svg
// module id = VBVJ
// module chunks = 39